// extracted by mini-css-extract-plugin
module.exports = {"character-counter":"character-counter_character-counter__EwkLF","character-counter--warning":"character-counter_character-counter--warning__7TWG3"};